module.exports = __webpack_public_path__ + "static/media/thumbnail2_ellen.41d91796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnail2_ellen.png
// module id = 115
// module chunks = 0